const formatDate = (value, locale = "fr-FR") => {
  return new Date(value).toLocaleDateString(locale, {
    day: "numeric",
    month: "long",
    year: "numeric",
  })
}

const formatDateNumeric = (value, month = "long", locale = "fr-FR") => {
  return new Date(value).toLocaleDateString(locale, {
    day: "numeric",
    month: "numeric",
    year: "numeric",
  })
}

const countDaysFromDate = (value, locale = "fr-FR") => {
 
  const date = new Date(value)
  const today = new Date()
  const timeDiff = Math.abs(today.getTime() - date.getTime())
  const diffDays = Math.round(timeDiff / (1000 * 3600 * 24))

  
  if (diffDays === 0) {
    return "aujourd'hui"
  } else if (diffDays <= 7) {
    return `${diffDays} jours`
  } else {
    const weeks = Math.floor(diffDays / 7)
    const remainingDays = diffDays % 7
    const weekString = weeks === 1 ? "1 semaine" : `${weeks} semaines`
    const dayString = remainingDays === 1 ? "1 jour" : `${remainingDays} jours`
    return `${weekString} et ${dayString}`
  }
}

module.exports = {
  formatDate,
  formatDateNumeric,
  countDaysFromDate,
}
